import applicant from './applicant';
import applicationDetails from './applicationDetails';
import applicationType from './applicationType';
import child from './child';
import exisitingOrder from './exisitingOrder';
import person from './person';
import protectedPersons from './protectedPersons';
import relatedOrders from './relatedOrders';
import respondent from './respondent';
import review from './review';
import yourCircumstances from './yourCircumstances';
import yourRole from './yourRole';

export const fvioEvrValidation = {
  applicant,
  applicationType,
  applicationDetails,
  child,
  exisitingOrder,
  relatedOrders,
  review,
  yourRole,
  yourCircumstances,
  protectedPersons,
  person,
  respondent,
};
